export default __webpack_public_path__ + "static/media/not-available.c9d1c72c.svg";